function IcoCheckBold() {
    return (
        <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.625 2.29167L2.29167 3.95833L5.625 0.625" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default IcoCheckBold;